import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import { FaExclamation } from 'react-icons/fa';
import MySelect from '../../components/MySelect';

const AddObservation2 = ({ eleve, onClose }) => {
    const [loading, setLoading] = useState(false);

    const { token, setToken, user } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [inputValueType, setValueType] = useState('');
    const [selectedType, setSelectedType] = useState(null);
    const [observationType, setObservationType] = useState([]);

    const [typesObservations, setTypesObservations] = useState([
        {
            id: 1,
            libelleFr: 'Positive',
            libelleAr: 'ايجابي'
        },
        {
            id: 2,
            libelleFr: 'Negative',
            libelleAr: 'سلبي'
        }
    ]);


    const [observation, setObservation] = useState({
        eleveId: eleve.id,
        observationType: '',
        observation: '',

    });

    const handleInputChangeType = value => {
        setValueType(value);
    };

    // handle selection


    // handle selection
    const handleChangeType = value => {
        setSelectedType(value);
        setObservation({ ...observation, observationType: value.id });

    }


    const navigate = useNavigate();

    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/observation/save', observation)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    // const getTypes = () => {
    //     axiosClient.get('/observationType')
    //         .then((data) => {
    //             setObservationType(data.data.types);
    //         }).catch(err => {
    //             const response = err.response;
    //             if (response.status === 401) {
    //                 setToken(null);
    //             }
    //             else {
    //                 if (response.status === 422) {
    //                     setErrors(response.data.errors);
    //                     setLoading(false);

    //                     toast.error('Merci de verifier les informations a saisies!', {
    //                         position: "top-right",
    //                         autoClose: 5000,
    //                         hideProgressBar: false,
    //                         closeOnClick: true,
    //                         pauseOnHover: true,
    //                         draggable: true,
    //                         progress: undefined,
    //                         theme: "light",
    //                     });
    //                 } else {
    //                     if (response.status === 403) {
    //                         navigate('/403');
    //                     } else {
    //                         if (response.status === 404) {
    //                             navigate('/404');
    //                         }
    //                         else {
    //                             navigate('/500');
    //                         }
    //                     }
    //                 }

    //             }
    //         })
    // }

    useEffect(() => {

    }, [])



    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header icon={<FaExclamation />} title={"Ajouter une observation sur " + eleve.eleve} titleAr={eleve.eleve + " إضافة ملاحظة"} />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }

                        <>
                            <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                <div className='flex-col w-full justify-evenly '>
                                    <div className='mr-2'>
                                        <MySelect label="Type" labelAr="النوع" placeholder="Type d'observation" cacheOptions defaultOptions value={selectedType} getOptionLabel={e => (user && user.langue === 'AR' ? e.libelleAr : e.libelleFr)} getOptionValue={e => e.id} options={typesObservations} onInputChange={handleInputChangeType} onChange={handleChangeType} />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Observation" labelAr="الملاحظة" type="text" value={observation.observation} onChange={ev => setObservation({ ...observation, observation: ev.target.value })} required="required" />
                                    </div>

                                </div>
                            </div>
                        </>

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                {loading ? <Loading /> :
                                    <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                }
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddObservation2